export default "__VITE_ASSET__5c63b4dc__$_?nuxt_component=async__"